<template>
  <button>
    {{ $t("common." + translationKey) }}
    <img src="@/assets/images/arrow_right.svg" alt="arrow-right" />
  </button>
</template>

<style lang="scss" scoped>
button {
  background-color: $YELLOW_ACCENTV3;
  padding: 16px 18px;
  color: $SECONDARY_TEXT_COLOR4;
  border: 0;
  border-radius: 8px;
  font-size: 1.125rem;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 19px;
  width: 258px;

  @media screen and (max-width: 500px) {
    padding: 16px 13px;
  }

  img {
    margin-left: 10px;
  }
}
</style>

<script >
 
export default {
  props: ["translationKey", "link"],
};
</script>
